 <template src="./MobilePanel.html" />

<script>
// plugins
import RadialProgressBar from 'vue-radial-progress';

// vuex
import { mapState } from 'vuex';
import gsap from "gsap";

export default {
  name: "MobilePanel",
  data() {
    return {
      questionsPositionData: false,
    }
  },
  components: {
    RadialProgressBar
  },
  computed: {
    ...mapState({
      UserAgent: 'UserAgent',
      scrollPercentageWithoutFilter: 'scrollPercentage',
      windowScrollPosition: 'windowScrollPosition',
      Screentest: 'Screentest'
    }),
    scrollPercentage() {
      return this.scrollPercentageWithoutFilter < 2 ? 0 :
          this.scrollPercentageWithoutFilter > 98 ? 100 :
              this.scrollPercentageWithoutFilter.toFixed(2) * 1
    },
    currentQuestion() {
      if(this.questionsPositionData) {
        const currentQuestion = (
            this.questionsPositionData[0].top > this.windowScrollPosition ? 0 :
            this.questionsPositionData[this.questionsPositionData.length - 1].bottom < this.windowScrollPosition ? this.questionsPositionData[this.questionsPositionData.length - 1] :
            this.questionsPositionData.findIndex((item) => {
              return this.windowScrollPosition > item.top && this.windowScrollPosition < item.bottom
            }) + 1
        );
      return currentQuestion > -1  ? currentQuestion : 0;
      } else {
        return 0
      }
    },
  },
  mounted() {
    setTimeout(() => {
      document.querySelectorAll('.questions__item').forEach((item, index) => {
        if (!this.questionsPositionData) this.questionsPositionData = [];
        const offset = this.$store.state.Screentest.isScreentest && index === 0 ? -300 : 0;
        this.questionsPositionData.push({
          top: item.getBoundingClientRect().top + window.pageYOffset + offset,
          bottom: item.getBoundingClientRect().bottom + parseInt(window.getComputedStyle(item).marginBottom) + window.pageYOffset,
        })
      });
    }, 500)
    document.addEventListener('scroll', () => {
      const screentestTriggerOffset = 100; // trigger for screentest mode (pixels from top)
      const koefTrigger = this.UserAgent.window.width > 600 ? 0.25 : 0.5; // 0 - trigger on TOP of screen, 1 - BOTTOM
      this.$store.dispatch('SET_WINDOW_SCROLL_POSITION', window.pageYOffset + (!this.$store.state.Screentest.isScreentest ? (window.innerHeight * koefTrigger) : screentestTriggerOffset));
    });
  },
  watch: {
    currentQuestion(newVal) {
      this.$store.dispatch('SET_CURRENT_QUESTION_ID', newVal);
    }
  },
  methods: {
    scrollToTop() {
      gsap.to(window, {duration: 0.6, scrollTo: 0});
    }
  }
}
</script>

<style scoped lang="scss" src="./MobilePanel.scss" />
